<template>
	<main ref="main" role="main" class="about">
		<!-- <div class="content-container"  v-html="">
    </div> -->
		<!-- <h2>Credits</h2><p>Design & Code by <a href=https://alfatih.world target=_blank>Alfatih</a><br>Typface is Riforma by <a href=https://lineto.com target=_blank>Lineto</a></p> -->
		<section class="aboutColumn">
			<div class="col">
				<h2>Address/Location</h2>
				<address class="vcard">
					<p>
						<span class="fn org">{{ infos.name }}</span
						><br />
						<a
							class="adr"
							:href="'https://g.page/wallstreet-offspace?share'"
							target="_blank"
						>
							<span class="street-address">{{ infos.address }}</span
							><br />
							<span class="postal-code">{{ infos.npa }} </span>
							<span class="locality">{{ infos.locality }}</span
							><br />
							<span class="country-name">{{ infos.country }}</span
							><br />
						</a>
					</p>
					<h2>Contact</h2>
					<p>
						<a class="email" :href="'mailto:' + infos.email">{{
							infos.email
						}}</a><br>
						<a :href="'tel:'+infos.phone.replace(/\s/g, '')">{{infos.phone}}</a>

					</p>
				</address>
				<h2>Open Hours</h2>
				<p>
					{{ infos.opendays }} {{ infos.openhours }}<br />
					Or by appointment
				</p>
				<h2>Keep in touch</h2>
				<p>
					<!-- <a :href="'https://wallriss.us19.list-manage.com/subscribe/post?u=2b4fdd4dce18b9460d18b7bec&amp%3Bid=7917b4a470&fbclid=IwAR3HV4Ltl72th2WdUAueEe8UG3jlPz_O54p8RNqVWit0ZivG-3sr86-Ix20'" target="_blank">Newsletter</a><br> -->
					<a :href="infos.instagram" target="_blank">Instagram</a><br />
					<a :href="infos.facebook" target="_blank">Facebook</a>
				</p>
				<form
					action="https://support.us18.list-manage.com/subscribe/post?u=118bca4bd4a1720f3ab0bdd71&amp;id=e9f9bcc23e"
					method="post"
					id="mc-embedded-subscribe-form"
					name="mc-embedded-subscribe-form"
					class="validate"
					target="_blank"
					novalidate
				>
					<label for="mce-EMAIL" class="nomargin">Newsletter</label>

					<input
						type="email"
						value=""
						name="EMAIL"
						class="email"
						id="mce-EMAIL"
						required
						placeholder="email address"
					/>

					<div
						style="position: fixed; left: -5000px; top: -5000px"
						aria-hidden="true"
					>
						<input
							type="text"
							name="b_2b4fdd4dce18b9460d18b7bec_7917b4a470"
							tabindex="-1"
							value=""
						/>
					</div>
					<div class="clear">
						<input
							type="submit"
							value="Subscribe"
							name="subscribe"
							id="mc-embedded-subscribe"
							class="button"
						/>
					</div>
				</form>


			</div>
			<div class="col">
				<vue-markdown
					:class="'aboutTextarea'"
					:source="pageAbout.aboutsecond"
					:anchorAttributes="{ target: '_blank' }"
				></vue-markdown>
				<vue-markdown
					:class="'aboutTextarea small'"
					:source="pageAbout.aboutthird"
					:anchorAttributes="{ target: '_blank' }"
				></vue-markdown>

				<!-- <vue-markdown :class="'aboutTextarea small'" :source="pageAbout.aboutfourth" :anchorAttributes="{target: '_blank'}"></vue-markdown> -->
			</div>
		</section>
	</main>
</template>

<script>
import VueMarkdown from 'vue-markdown';

export default {
	name: 'about',
	components: {
		VueMarkdown,
	},
	metaInfo() {
		return {
			title: this.title,
		};
	},
	computed: {
		pageAbout() {
			return this.$store.getters.getPageByUID('about');
		},
		infos() {
			return this.$store.getters.getPageByUID('infos');
		},
	},
	data() {
		return {
			title: this.$store.getters.getPageByUID('about').title,
		};
	},
	mounted() {
		this.$refs.main.focus();
	},
};
</script>

<style lang="scss">
@import './../assets/styles/general/mixins';
@import './../assets/styles/config';
.about {
	// display: flex;
	// flex-wrap: wrap;
	// flex-direction: row-reverse;
	height: 100%;
	width: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;
	// position: absolute;
	// top: 0;
	// left: 0;

	::-moz-selection {
		/* Code for Firefox */
		color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
		// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
		text-shadow: 0px 0px 0.1em black;
	}

	::selection {
		color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
		// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
		text-shadow: 0px 0px 0.1em black;
	}
	.aboutColumn {
		// background: yellow;
		display: flex;
		flex-wrap: wrap;
		padding: 1.6em 1.6em;
		// height: 100%;
		// overflow-y: auto;
		// -webkit-overflow-scrolling: touch;
		align-items: flex-start;
		align-content: flex-start;
		@include fluid-type(350px, 1400px, 5px, 12px);
	}
	.col {
		@media screen and (max-width: $mq-tablet) {
			max-width: none;
			// margin-bottom: 3em;
		}
		&:first-child {
			@media screen and (max-width: $mq-tablet) {
				max-width: none;
				// margin-bottom: 3em;
			}
			flex-grow: 1;
			max-width: 50%;
			margin-right: 2em;
		}
	}
	p {
		font-size: 5em;
		margin-bottom: 0.3em;
		margin-top: 0.15em;
		line-height: 1;
		text-transform: uppercase;
		@media screen and (max-width: 1450px) {
			font-size: 4.5em;
		}
		&.email {
			margin-bottom: 0;
			padding-top: 0.05em !important;
		}
		@media screen and (max-width: $mq-tablet) {
			font-size: 5em;
		}
	}
	form {
		overflow: visible;
	}
	input {
		font-size: 4.5em;
		overflow: visible;
		display: block;
		line-height: 1;
		@media screen and (max-width: $mq-tablet) {
			font-size: 5em;
		}
		&.email {
			margin-top: 0.15em;
		}
		&.hide {
			color: transparent;
			position: absolute;
		}
	}
	h1,
	h2,
	label,
	p.small,
	p.small *,
	.small p,
	.small p *,
	h1 *,
	h2 * {
		font-size: 1.4rem;
		font-family: Arial;
		font-weight: bold;
		text-transform: none;
		margin-top: 0;
		line-height: 1.2;
		@media screen and (max-width: 600px) {
			font-size: 1.2rem;
		}
	}
	.small p {
		margin-bottom: 1em;
	}
	h2.nomargin,
	label.nomargin {
		margin-bottom: 0;
	}
	input {
		background: transparent;
		border: 0;
		border-radius: 0;
		outline: none;
		-webkit-appearance: none;
		padding-top: 0.05em !important;
		box-shadow: 0 0;
		vertical-align: middle;
		overflow: visible;
		text-transform: uppercase;
		&::placeholder {
			overflow: visible;
		}
		&[type='email'] {
			text-align: left;
			width: 11.5em;
		}
		&::-moz-selection {
			/* Code for Firefox */
			background: #f0f0f0;
			color: black;
		}

		&::selection {
			background: #f0f0f0;
			color: black;
		}
	}
	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active {
		-webkit-box-shadow: 0 0 0 60px white inset !important;
		background-color: white !important;
		background-clip: content-box !important;
	}
	h2 {
		// margin-bottom: 0.5em;
	}
	p.small,
	form {
		margin: 0;
		margin-bottom: 1em;
	}
}
</style>
